export default __webpack_public_path__ + "static/media/Logo-black.d0386b1d.png";